<template>
    <div class="pie-chart-container pt-5 pr-5">
        <Pie
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
  />
    </div>
  
</template>

<script>
import { Pie } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, ChartDataLabels)

export default {
  name: 'PieChart',
  components: {
    Pie
  },
  props: {
    chartId: {
      type: String,
      default: 'pie-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: 300
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    jobseekerInterview: {
      type: Array,
      required: true
    },
    jobseekerInterviewInPercent: {
      type: Array,
      required: true
    }
  },
  computed: {
  chartData() {
    return {
    labels: ['To be Scheduled', 'Scheduled'],
        datasets: [
          {
            backgroundColor: ['#AC9EE4','#9EC9FF'],
            data: this.jobseekerInterviewInPercent
          }
        ],
    }
  }
},
  mounted() {
    this.updateFontSizeForBreakpoint();
    window.addEventListener('resize', this.updateFontSizeForBreakpoint);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateFontSizeForBreakpoint);
  },
  methods: {
    updateFontSizeForBreakpoint() {
      const width = window.innerWidth;
      const isSmall = width <= 1380;

      // Update chartOptions plugin font sizes
    
      this.chartOptions.plugins.datalabels.font.size = isSmall ? 10 : 12;
    },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
            position: 'right',// ✅ moves legend to the right
            labels: {
              font: {
                size: 14 // ✅ Font size for legend labels
              },
              usePointStyle: true,      // ✅ Allows custom shape
              pointStyle: 'rect',       // ✅ Makes legend marker square      
            }
            },
            tooltip: {
          callbacks: {
            label: (tooltipItem) => {
              const datasetLabel = tooltipItem.dataset.label     // 'Screening' or 'Mains'
              const label = tooltipItem.label                    // 'Pass' or 'Fail'
              const index = tooltipItem.dataIndex                // 0 or 1
              const percentage = tooltipItem.raw                 // value from screeningData / mainsData

              
              let count = this.jobseekerInterview[index]
              return `${label}: ${percentage}% (${count})`
            }
          }
        },
        datalabels: {
          color: '#000', // 💡 text color on the chart
          font: {
            size: 12
          },
          formatter: (value) => {
            return value === 0 ? null : `${value}%`;// append percent sign
          }
        }
        },
        
      }
    }
  }
}
</script>
<style scoped>
.pie-chart-container {
  width: 100%;
  height: 100%;
  max-width: 100%;
  margin: auto;
  position: relative;
}
</style>
